import { mergeWith } from 'lodash-es';

/** Deep merges a config on top of a provided base. Filters out undefined sources. */
export const deepMergeConfig = <T>(sources: (T | undefined)[], base: T): T => {
  const object = {};
  mergeWith(
    object,
    base,
    ...sources.filter((source) => source !== undefined),
    concatArrays
  );
  return object as T;
};

const concatArrays = <T>(objValue: T[], srcValue: T[]): T[] | undefined => {
  if (Array.isArray(objValue)) {
    return [...objValue, ...srcValue];
  }
  return undefined;
};
